import { CanActivateFn } from '@angular/router';

import { ROLES_MANAGE } from './capabilities';
import { tenantAdminToolGuard } from './tenant-admin-tool.guard';

export const TENANT_MEMBERSHIPS_MANAGE = 'tenant_memberships.manage';

/** CSMs hold `tenant_memberships.manage`; tenant admins get a reduced page through `roles.manage`. */
export const MEMBERSHIPS_ADMIN_KEYS: readonly string[] = [TENANT_MEMBERSHIPS_MANAGE, ROLES_MANAGE];

export const tenantMembershipsAdminGuard: CanActivateFn =
  tenantAdminToolGuard(MEMBERSHIPS_ADMIN_KEYS);
